import {UmpireComponent} from '../umpire-component';
import {UmpireComponentTypeEnum} from '../umpire-component-type-enum';
import {UmpireImageOrientation} from '../umpire-image-orientation';
import {UmpireOttPlaylist} from '../umpire-ott-playlist';

export interface UmpireComponentOttPlaylistList
  extends UmpireComponent<UmpireComponentTypeEnum.OTT_PLAYLIST_LIST> {
  playlists_order: PlaylistOrder[];
  auto_pick: boolean;
  is_featured: boolean;
  image_orientation: UmpireImageOrientation;
  name: string;
  playlists?: UmpireOttPlaylist[];
}

export interface PlaylistOrder {
  playlist_id: string;
  playlist_index: number;
}
